import * as React from 'react';
import {
  LandingPayload,
  SectionUIProps,
  AppLocalizationKey,
} from '~/common/types/types';
import { getValidClasses } from '~/helpers/helpers';
import {
  Button,
  FormattedMessage,
  SectionLayout,
} from '~/components/common/common';
import { Description, LandingList } from './components/components';
import * as styles from './landing.module.scss';

type Props = SectionUIProps & {
  classes?: {
    sectionLayout?: React.ComponentProps<typeof SectionLayout>['classes'];
    title?: string;
    subtitleTop?: string;
    subtitleBottom?: string;
    button?: string;
    container?: string;
    contentWrapper?: string;
    mediaWrapper?: string;
  };
  payload: LandingPayload;
  onMove?: (evt: React.MouseEvent) => void;
  onScroll?: (evt: React.UIEvent) => void;
  registrationLink: string | null;
};

const Landing: React.FC<Props> = ({
  classes,
  payload,
  onMove,
  onScroll,
  registrationLink,
  sectionHighlight,
  children,
}) => {
  const {
    title,
    subtitleTop,
    subtitleBottom,
    description,
    items,
    registrationBtn,
    registrationEnd,
  } = payload;

  const hasRegistrationLink = Boolean(registrationLink);
  const hasSubtitleTop = Boolean(subtitleTop);
  const hasSubtitleBottom = Boolean(subtitleBottom);
  const hasItems = Boolean(items?.length);

  return (
    <SectionLayout
      sectionHighlight={sectionHighlight}
      classes={classes?.sectionLayout}
    >
      <div
        className={getValidClasses(styles.container, classes?.container)}
        onMouseMove={onMove}
        onScrollCapture={onScroll}
      >
        <div
          className={getValidClasses(
            styles.contentWrapper,
            classes?.contentWrapper,
          )}
        >
          {hasSubtitleTop && (
            <p
              className={getValidClasses(styles.subtitle, classes?.subtitleTop)}
            >
              <FormattedMessage message={subtitleTop as AppLocalizationKey} />
            </p>
          )}
          <b className={getValidClasses(styles.title, classes?.title)}>
            <FormattedMessage message={title} />
          </b>
          {hasSubtitleBottom && (
            <p
              className={getValidClasses(
                styles.subtitle,
                classes?.subtitleBottom,
              )}
            >
              <FormattedMessage
                message={subtitleBottom as AppLocalizationKey}
              />
            </p>
          )}
          <div className={styles.listWrapper}>
            {hasRegistrationLink ? (
              <Button
                btnColor="pink"
                gtm="sign_up"
                className={getValidClasses(
                  'pixel-corners',
                  styles.btn,
                  classes?.button,
                )}
                externalLink={registrationLink as string}
                withLanguageQuery
                hasShadow
              >
                <FormattedMessage message={registrationBtn} />
              </Button>
            ) : (
              <p className={styles.registration}>
                <FormattedMessage message={registrationEnd} />
              </p>
            )}
            {hasItems ? (
              <LandingList items={items} description={description} />
            ) : (
              <Description description={description} />
            )}
          </div>
        </div>
        <div
          className={getValidClasses(
            styles.mediaWrapper,
            classes?.mediaWrapper,
          )}
        >
          {children}
        </div>
      </div>
    </SectionLayout>
  );
};

export { Landing };
